import { Link } from "react-router-dom";
import { ArrowRight, PenTool } from "lucide-react";
import BeforeAfterSlider from "@/components/BeforeAfterSlider";
import { useAuth } from "@/context/AuthContext";

const EXAMPLES = [
  { key: "cafe", name: "Little Leaf Cafe", note: "Pencil doodle · Minimal style" },
  { key: "surf", name: "Salt & Swell Surf School", note: "Notebook sketch · Modern style" },
  { key: "dog", name: "Sudsy Pups Dog Grooming", note: "Napkin drawing · Playful style" },
];

export const SketchShowcase = () => {
  const { user } = useAuth();
  return (
    <section className="border-b border-black/5 bg-white" data-testid="sketch-showcase">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-12">
          <div className="md:col-span-7">
            <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#52525B] mb-3 flex items-center gap-2"><PenTool className="w-3.5 h-3.5 text-[#ED5A24]" /> Sketch to logo</div>
            <h2 className="text-3xl md:text-4xl tracking-tighter font-black leading-[1.05]">
              Only have a sketch?<br /><span className="text-[#ED5A24]">We'll make it a logo.</span>
            </h2>
          </div>
          <p className="md:col-span-5 text-base text-[#52525B] leading-relaxed">
            Snap a photo of your doodle, add your business name and pick a style. AI redraws it as a polished logo, then Pesky Pixel turns it into real vector files. Drag each slider to compare.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {EXAMPLES.map((e) => (
            <figure key={e.key} className="bg-white border border-black/10 shadow-[6px_6px_0_0_#F4F4F5]" data-testid={`sketch-example-${e.key}`}>
              <BeforeAfterSlider beforeSrc={`/sketch-${e.key}-before.jpg`} afterSrc={`/sketch-${e.key}-after.jpg`}
                beforeLabel="Sketch" afterLabel="Logo" bgChecker={false} />
              <figcaption className="px-4 py-3 border-t border-black/10">
                <div className="font-bold text-sm">{e.name}</div>
                <div className="text-xs text-[#52525B]">{e.note}</div>
              </figcaption>
            </figure>
          ))}
        </div>
        <div className="mt-10 flex flex-wrap items-center gap-4">
          <Link to={user ? "/sketch" : "/register"} data-testid="sketch-showcase-cta"
            className="inline-flex items-center gap-2 bg-[#ED5A24] hover:bg-[#0A0A0B] text-white text-xs uppercase tracking-[0.2em] font-bold h-12 px-8 transition-colors duration-200">
            Turn my sketch into a logo <ArrowRight className="w-4 h-4" />
          </Link>
          <span className="text-xs text-[#52525B]">5 free tries a day · A$10 to unlock the files · sample brands made for demonstration</span>
        </div>
      </div>
    </section>
  );
};
